import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'
import { AnchorScroller } from '../modules/anchor-scroller.js'
import PinnedLayers from '../modules/pinned-layers.js'

//
export default class extends Component {
	prepare() {
		// prepare pinned layers
		this.layers = this.element.querySelectorAll('[data-layer]')
		this.pinnedLayers = new PinnedLayers({ layers: this.layers })
		this.pinnedLayers.init()

		console.log(this.pinnedLayers)

		this.bndOnContentReplace = this.onContentReplace.bind(this)
		EventBus.on('swup:content:replace', this.bndOnContentReplace)

		// this.bndHandleHash = this.handleHash.bind(this)
		// window.addEventListener('hashchange', this.bndHandleHash)
	}

	mount() {
		console.log('body component mounted')

		this.anchorScroller = new AnchorScroller({
			scope: this.element,
			onBeforeScroll: () => {
				console.log('aiaiai')
				// if (!this.overlayVisible) return
				// this.hideOverlay()
			},
		})
		this.anchorScroller.bind()
	}

	unmount() {
		console.log('body component unmounted')
		if (this.pinnedLayers) {
			this.pinnedLayers.destroy() // Assuming you have a destroy method to clean up ScrollTriggers
		}

		if (this.anchorScroller) {
			this.anchorScroller.destroy() // Assuming you have an unbind method to remove event listeners
		}
	}

	onContentReplace() {
		console.log('Content replaced, re-initializing pinned layers')
		// re-initialize pinned layers after content replacement
		this.layers = this.element.querySelectorAll('[data-layer]')
		this.pinnedLayers = new PinnedLayers({ layers: this.layers })
		this.pinnedLayers.init()
	}
}
